import { Box, Typography } from "@material-ui/core";
import * as React from "react";
import { useRecoilValueLoadable } from "recoil";

import { PROPERTY_TYPE_VALUES } from "@/api/mappings/property";
import { semanticColors as colors, textStyles } from "@/designTokens";
import type { PropertyHolder } from "@/view_models/atoms";
import { MonthlyBalanceSheets } from "@/view_models/balancesheetSelectors";

import { calculateCashflowAverage } from "./calculateCashflowAverage";

export const CashflowAverage: React.FC<{ property: PropertyHolder }> = ({ property }) => {
  const monthly = useRecoilValueLoadable(MonthlyBalanceSheets(property.id));
  const { average, monthCount } = calculateCashflowAverage(
    monthly.state === "hasValue" ? monthly.contents : new Map(),
    property.property.property_category,
    property.property.property_type === PROPERTY_TYPE_VALUES.consideration ? null : property.property.bought_at
  );
  const value =
    monthCount === 0 || monthly.state === "hasError"
      ? "未算出"
      : monthly.state === "loading"
        ? "読み込み中"
        : average === null
          ? "未算出"
          : `${average.toLocaleString()}円`;
  return (
    <Box mt={2} aria-label="直近12か月の平均収支" display="flex" justifyContent="space-between" gridGap={16}>
      <Typography style={{ ...textStyles["SP/Body/Small"], color: colors["text/secondary"] }}>
        直近12か月の平均
        <br />
        対象{monthCount}か月
      </Typography>
      <Typography
        style={{
          ...textStyles["Number/S"],
          color: average !== null && average < 0 ? colors["text/error"] : colors["text/primary"],
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};
